<template>
<div class="container">
    <div class="row">
        <div class=" btn-home  col-md-12 mt-3 mb-4 d-flex justify-content-end">
            <button type="button" class="btn btn-outline-main" @click="returnHome">
                <i class="fas fa-home-lg-alt"></i> Inicio
            </button>
        </div>
    </div>
    <div class="row">
        <div class="card w-100 px-0">
            <div class="card-header h4 bg-main text-white text-center">
                <strong>REPORTE CXP</strong>
            </div>
            <div class="card-body">
                <div class="row">
                    <!-- FILTROS -->
                    <div class="col-md-12">
                        <div class="d-md-flex flex-wrap justify-content-between">
                            <div class="col-xl-2 col-md-6 col-lg-3 col-sm-12 mb-2 px-1">
                                <div class="input-group input-group-sm">
                                    <span class="input-group-text col-md-4">Desde</span>
                                    <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="begindate" v-model="filter.start_date" @change="mtdGetData" />
                                </div>
                            </div>
                            <div class="col-xl-2 col-md-6 col-lg-3 col-sm-12 mb-2 px-1">
                                <div class="input-group input-group-sm">
                                    <span class="input-group-text col-md-4">Hasta</span>
                                    <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="enddate" v-model="filter.end_date" @change="mtdGetData" />
                                </div>
                            </div>
                            <div class="col-xl-5 col-lg-6 col-md-12 col-sm-12 mb-2 px-3">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="row d-flex card-filter">
                                                <div class="col-lg-3 col-md-3 col-sm-12 bg-secondary-subtle">
                                                    <span>Tipo</span>
                                                </div>
                                                <div class="col-lg-9 col-md-9 col-sm-12 d-flex align-items-center">
                                                    <div v-for="(option, index) in filterOptions" :key="index" class="form-check form-check-inline">
                                                        <input class="form-check-input" type="checkbox" :id="'inlineCheckbox' + index" :value="option.value" v-model="filter.type" @change="mtdGetData" />
                                                        <label class="form-check-label" :for="'inlineCheckbox' + index">{{ option.label }}</label>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            <div class="col-xl-3 col-md-12 col-lg-12 col-sm-12 mb-2 px-1">
                                <div class="input-group input-group-sm">
                                    <span class="input-group-text text-white bg-main cursor-pointer" @click="mtdGetData">
                                        <i class="fas fa-search"></i>&nbsp;&nbsp;Filtrar
                                    </span>
                                    <input type="text" class="form-control form-control-sm" placeholder="Buscar por proveedor" v-model="search" @input="calculateData(10)" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- TABLA -->
                    <div class="col-md-12">
                        <div class="row">
                            <div v-if="cpData.length > 0" class="d-flex justify-content-end mb-2">
                                <nav aria-label="Page navigation example ">
                                    <ul class="pagination mb-0 ">
                                        <li class="page-item">
                                            <a class="page-link page" href="javascript:void(0)" @click="backPage">Anterior</a>
                                        </li>
                                        <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                                            <a :class="selectPage === 1 ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(1)">1</a>
                                        </li>
                                        <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>

                                        <li v-for="(item, index) in limitedStepPagination" :key="index" class="page-item">
                                            <a :class="selectPage === item ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(item)">{{ item }}
                                            </a>
                                        </li>
                                        <li v-if="limitedStepPagination[limitedStepPagination.length - 1] < stepPagination.length - 1" class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>
                                        <li v-if="limitedStepPagination[limitedStepPagination.length - 1] !== stepPagination.length" class="page-item">
                                            <a :class="selectPage === limitedStepPagination.length + 2 ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(stepPagination.length)">{{
                                                    stepPagination.length }}
                                            </a>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link page" href="javascript:void(0)" @click="nextPage">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                            <div class="col-md-12 mb-4 px-2" id="content-timelinetable">
                                <table class="table table-bordered border-main" aria-describedby="mydesc">
                                    <caption class="py-0 my-0"></caption>
                                    <thead>
                                        <tr class="text-white border-white text-center bg-main text-xs align-middle">
                                            <th scope="col">N°</th>
                                            <th class="nowrap">PROVEEDOR
                                                <i class="fa fa-arrow-up arrow-order" @click="sortData('provider_name', 'asc')"></i>
                                                <i class="fa fa-arrow-down arrow-order" @click="sortData('provider_name', 'desc')"></i>
                                            </th>
                                            <th class="nowrap">MONTO
                                                <i class="fa fa-arrow-up arrow-order" @click="sortData('amount', 'asc')"></i>
                                                <i class="fa fa-arrow-down arrow-order" @click="sortData('amount', 'desc')"></i>
                                            </th>
                                            <th scope="col">MONEDA</th>
                                            <th scope="col">FECHA DE ABONO</th>
                                            <th scope="col">FACTURA/RH</th>
                                            <th scope="col">PDF FACTURA/RH</th>
                                            <th scope="col" class="nowrap">MOTIVO
                                                <i class="fa fa-arrow-up arrow-order" @click="sortData('motive_bill', 'asc')"></i>
                                                <i class="fa fa-arrow-down arrow-order" @click="sortData('motive_bill', 'desc')"></i>
                                            </th>
                                            <th scope="col">N° CUENTA CONTABLE</th>
                                            <th class="nowrap">F. FACTURA
                                                <i class="fa fa-arrow-up arrow-order" @click="sortData('bill_date', 'asc')"></i>
                                                <i class="fa fa-arrow-down arrow-order" @click="sortData('bill_date', 'desc')"></i>
                                            </th>
                                            <th scope="col">FECHA DE VENCIMIENTO</th>
                                            <th scope="col">CENTRAL DE COSTO</th>
                                            <th scope="col">MEDIO DE PAGO</th>
                                            <th scope="col">PDF</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-xxs">
                                        <tr v-if="cpData.length === 0">
                                            <td colspan="14" class="text-center">No se encontraron resultados de pagos</td>
                                        </tr>
                                        <tr v-for="(item, index) in cpData" :key="index" :class="getRowClass(item)">
                                            <td>{{ mtdNumber(index) }}</td>
                                            <td>{{ item.provider_name }}</td>
                                            <td>{{ item.amount }}</td>
                                            <td>{{ item.currency ?? 'SOLES' }}</td>
                                            <td>{{ item.date }}</td>
                                            <td>{{ item.bill.number }}
                                            </td>
                                            <td>
                                                <button type="button" class="btn btn-sm btn-info mt-1" :disabled="item.bill.file !== ''" @click="viewBill(item.bill.file)">
                                                    <i class="fa fa-eye"></i>
                                                </button>
                                            </td>
                                            <td>PAGO DE {{ item.motive_bill }}</td>
                                            <td>{{ mtdAcount(item) }}</td>
                                            <td>{{ item.bill_date }}</td>
                                            <td>{{ item.bill_due_date }}</td>
                                            <td>{{ item.central_costo }}</td>
                                            <td>{{ mtdMessage(item)}}</td>
                                            <td>
                                                <button type="button" class="btn btn-sm btn-warning" @click="mtdViewPdfAdjunto(item)" :disabled="!item.file" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" title="This top tooltip is themed via CSS variables.">
                                                    <i class="fa fa-file-pdf"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions
} from "vuex";
export default {
    name: 'c-Administracion-ReporteCxp',
    data() {
        return {
            data: [],
            dataShow: [],
            search: '',
            filter: {
                start_date: '',
                end_date: '',
                type: ['bill', 'bill_services', 'bill_others', 'bill_actives']
            },
            filterOptions: [{
                    label: 'Medicamentos',
                    value: 'bill'
                },
                {
                    label: 'Servicios',
                    value: 'bill_services'
                },
                {
                    label: 'Otros',
                    value: 'bill_others'
                },
                {
                    label: 'Activos',
                    value: 'bill_actives'
                },
            ],
            //Paginado
            page: 0,
            selectPage: 1,
            stepPagination: [],
            totalPagesToShow: 4,
            // Estado de orden
            sortKey: '',
            sortOrder: '',
        };
    },
    watch: {
        selectPage() {
            this.calculateData(10);
        },
    },
    created() {
        this.getFirstDayOfMonth();
    },
    computed: {
        cpData() {
            return this.dataShow;
        },
        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;

            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }

            return Array.from({
                    length: endPage - startPage + 1,
                },
                (_, i) => startPage + i
            );
        },

    },
    methods: {
        ...mapActions(["post"]),
        getRowClass(item) {
            return {
                'bg-light-green': item.modulo === 'bill',
                'bg-light-blue': item.modulo === 'bill_services',
                'bg-indigo': item.modulo === 'bill_others',
                'bg-light-red': item.modulo === 'bill_actives',
            };
        },
        getFirstDayOfMonth: function () {
            const currentDate = new Date();
            const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 7);
            const today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
            this.filter.start_date = firstDayOfMonth.toISOString().split('T')[0];
            this.filter.end_date = today.toISOString().split('T')[0];
            this.mtdGetData();
        },
        mtdGetData: function () {
            if(this.filter.type.length === 0){
                this.data = [];
                this.calculateData(10);
                return;
            }
            this.post({
                    url: this.$store.getters.get__url + "/Administracion/reportBillPayment",
                    token: this.$store.getters.get__token,
                    params: this.filter
                })
                .then((response) => {
                    this.data = response.data;
                    this.calculateData(10);
                })
                .catch((errors) => {
                    this.$refs.SweetAlert.showError(errors);
                });
        },
        calculateData(items) {
            if (!this.data || !this.data.length) {
                return (this.dataShow = []);
            }
            let filteredData = this.data;
            let indexInitial = this.selectPage;
            if (this.search.length >= 2 && this.search != "") {
                let query = this.search.toString().toUpperCase();
                filteredData = this.data.filter((element) => {
                    let name = element.provider_name.toString().toUpperCase();
                    return name.includes(query);
                });
                indexInitial = 1;
            }

            let totalPages = Math.ceil(filteredData.length / items);
            this.stepPagination = Array.from({
                    length: totalPages,
                },
                (_, index) => index + 1
            );
            if (this.selectPage > totalPages) {
                this.selectPage = totalPages || 1; // Manejar el caso donde no haya datos
            }
            let startIndex = (indexInitial - 1) * items;
            let endIndex = startIndex + (items - 1);
            this.dataShow = filteredData.slice(startIndex, endIndex + 1);
        },
        sortData(key, order) {
            if (this.sortKey && this.sortKey !== key) {
                this.sortOrder = '';
            }
            this.sortKey = key;
            this.sortOrder = order;

            this.data.sort((a, b) => {
                let result = 0;

                // Convertir valores a números si la clave es 'price_unit' o 'valorizado'
                const valueA = key === 'amount' ? parseFloat(a[key]) : a[key];
                const valueB = key === 'amount' ? parseFloat(b[key]) : b[key];
                if (valueA < valueB) result = -1;
                if (valueA > valueB) result = 1;

                return order === 'asc' ? result : -result;
            });
            this.calculateData(10);
        },
        mtdViewPdfAdjunto(item) {
            //mostrar en otra pestaña
            window.open(
                "https://clinicabm.v2.howertpi.com/assets/" + item.file,
                "_blank"
            );
        },
        viewBill(file) {
            //mostrar en otra pestaña
            window.open(
                "https://clinicabm.v2.howertpi.com/assets/" +file,
                "_blank"
            );
        },
        mtdMessage(item) {
            //PAGADO POR MEDIO DEL {{ item.metodo }} - CUENTA {{ item.bank_name }}
            if (item.metodo === 'BANCO') {
                return item.metodo + " - CUENTA " + item.bank_name + " " + item.bank_currency;
            } else {
                return item.metodo
            }
        },
        mtdAcount(item) {
            return item.currency == 'SOLES' ? '421201' :(item.currency == 'DOLARES' ? '421202' : "");
        },
        //Paginacion
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage =
                this.selectPage < this.stepPagination.length ?
                this.selectPage + 1 :
                this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
        mtdNumber: function (index) {
            return (this.selectPage - 1) * 10 + (index + 1)
        },
        returnHome: function () {
            this.$emit("changePage", 'home');
        },
    }
};
</script>
